import { Cronjob } from "Models/cronjob";
import API from "../api";

import BaseService from "./_base.service";
import { AxiosResponse } from "axios";

const endpoint = "report/management";

const ReportManagementService = {
  ...BaseService<Cronjob>({ endpoint }),
  async createManagement(data: Cronjob, filters?: any): Promise<AxiosResponse<Cronjob>> {
    return await API.post(`${endpoint}/create-subscription`, data, { params: filters })
  },
  async updateManagement(data: Partial<Cronjob> & { changes?: string }): Promise<AxiosResponse<boolean>> {
    return await API.put(`${endpoint}/update-subscription`, data);
  },
  async deleteManagement(data: Cronjob): Promise<AxiosResponse<boolean>> {
    return await API.put(`${endpoint}/delete-subscription`, data);
  },
  async deleteManagementList(data: Cronjob[]): Promise<AxiosResponse<boolean>> {
    return await API.put(`${endpoint}/delete-subscription/list`, data);
  }
};

export default ReportManagementService;
